import { Route as HomeRoute } from "@/routes/(auth)/_headed/home";
import { useRouter } from "@tanstack/react-router";
import { Button } from "web-design-system";
import { BrandedAppBackground } from "./brandedAppBackground";

export default function NotFoundPage() {
  const router = useRouter();

  return (
    <BrandedAppBackground className="h-dvh w-dvw">
      <div className="flex flex-col items-center gap-5 justify-center size-full">
        <h1>🚨 404 – Page Not Found</h1>
        <p className="text-center text-muted-foreground">
          It looks like this page isn’t part of your portfolio.
          <br /> But don’t worry—your investments are safe.
        </p>
        <Button
          onClick={() =>
            router.navigate({
              to: HomeRoute.fullPath,
            })
          }
          size="lg"
        >
          Go to Home
        </Button>
      </div>
    </BrandedAppBackground>
  );
}
